export enum OperacionTransferenciaTercerosTipoOperacion  {
    FCC= 1,
    TRANSFERENCIATERCEROS = 2,
}